import React from 'react'

import styles from './styles.module.scss'

type Props = {
  spacing?: 'sm' | 'base' | 'lg' | 'none'
}

const HorizontalDivider = ({ spacing = 'base' }: Props) => {
  const marginY = spacing === 'base' ? 'my-3' : spacing === 'lg' ? 'my-4' : spacing === 'sm' ? 'my-2' : 'my-0'

  return (
    <div className={`${marginY} ${styles.horizontalLine}`}></div>
  )
}

export default HorizontalDivider